<h1><a href=".">{{title}} v{{version}}</a></h1>
<div class="color-palette">
  <table>
    <tr *ngFor="let r of color_palette; let i = index">
      <td *ngFor="let c of r; let j = index">
        <div [style]="colorPaletteStyle(i, j)" [class]="colorPaletteClass(i, j)"
             (click)="onColorPaletteClick(i, j)"></div>
      </td>
    </tr>
  </table>
</div>
<div class="resolution">
  <mat-form-field>
    <mat-label>Resolusion</mat-label>
    <mat-select name="resolution" [(ngModel)]="resolution">
      <mat-option *ngFor="let dpi of resolutionOptions" [value]="dpi">{{dpi}}dpi</mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div class="font">
  <mat-form-field>
    <mat-label>Font</mat-label>
    <mat-select name="font" [(ngModel)]="font">
      <mat-option *ngFor="let f of fontOptions" [value]="f.id">{{f.name}}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div class="jfont">
  <mat-form-field>
    <mat-label>Japanese Font</mat-label>
    <mat-select name="jfont" [(ngModel)]="jfont">
      <mat-option *ngFor="let f of jfontOptions" [value]="f.id">{{f.name}}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div class="options">
  <mat-checkbox [(ngModel)]="bold">Bold-face</mat-checkbox>
  <mat-checkbox [(ngModel)]="opaque">White background</mat-checkbox>
</div>
<div class="command">
  <table>
    <tr>
      <td colspan="3">
        <button class="generate" matFab extended (click)="onGenerateClick()">
          <mat-icon inline="false">sync</mat-icon>Generate
        </button>
      </td>
    </tr>
    <tr>
      <td>
        <button class="download" matButton="outlined" (click)="onDownloadClick('png')">
          <mat-icon inline="false">vertical_align_bottom</mat-icon>PNG
        </button>
      </td>
      <td>
        <button class="download" matButton="outlined" (click)="onDownloadClick('eps')">
          <mat-icon inline="false">vertical_align_bottom</mat-icon>EPS
        </button>
      </td>
      <td>
        <button class="download" matButton="outlined" (click)="onDownloadClick('svg')">
          <mat-icon inline="false">vertical_align_bottom</mat-icon>SVG
        </button>
      </td>
    </tr>
    <tr>
      <td>
        <button class="download" matButton="outlined" (click)="onDownloadClick('dvi')">
          <mat-icon inline="false">vertical_align_bottom</mat-icon>DVI
        </button>
      </td>
      <td>
        <button class="download" matButton="outlined" (click)="onDownloadClick('pdf')">
          <mat-icon inline="false">vertical_align_bottom</mat-icon>PDF
        </button>
      </td>
      <td>
        <button class="download" matFab extended (click)="onDownloadClick('gif')">
          <mat-icon inline="false">vertical_align_bottom</mat-icon>GIF
        </button> </td>
    </tr>
    <tr>
      <td colspan="3">
        <button class="reset" matFab extended (click)="onResetClicked()">
	  <mat-icon>delete_outline</mat-icon>Reset
	</button>
      </td>
    </tr>
  </table>
</div>
